// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ComparisonButton_wrap__6udN3","main":"ComparisonButton_main__LW5HB","icon":"ComparisonButton_icon__Kr87e","remove":"ComparisonButton_remove__za2LD"};